<div class="main-container">
  <app-progress-bar [pageNames]="starterPages" />

  <router-outlet></router-outlet>
</div>
